import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { LoggedInUserModel } from '../../core/models/logged-in-user.model';
import { UserCredentialsModel } from '../../core/models/registered-user-login/user-credentials.model';
import { GlobalEventsManagerService } from '../../core/services/global-events-manager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityService } from '../../core/services/security.service';
import { CONFIG } from '../../core/config';
import { Route } from '@angular/compiler/src/core';

@Component({
    selector: 'app-registered-user-login',
    templateUrl: './registered-user-login.component.html'
})
export class RegisteredUserLoginComponent implements OnInit {
    public showPwd: boolean = false;
    public userCredentials: UserCredentialsModel;
    public loggedInUser: LoggedInUserModel;

    constructor(private _loginService: LoginService,
        private _eventsManagerService: GlobalEventsManagerService,
        private _router: Router, private _route: ActivatedRoute,
        private _securityService: SecurityService) {
        this.userCredentials = new UserCredentialsModel();
    }

    ngOnInit() {
        this.initUser();
    }

    initUser() {
        this.userCredentials.applicationTypeID = CONFIG.applicationType;
    }

    showPasswordToggle() {
        this.showPwd = !this.showPwd;
    }

    onSubmit() {
        this._loginService.registeredUserLogin(this.userCredentials).subscribe(result => {
            if (result != null && result.id > 0 && result.isLoggedIn == true) {
                if (result.isVerificationRequired == true && result.id != null && result.id>0) {
                    this._router.navigate(['/register/registered-user-verification/' + result.id]);
                }
                else {               
                this.loggedInUser = result;
                this._securityService.saveToLocalStorage(this.loggedInUser);
                    this._eventsManagerService.loggedIn(true);

                    let params = this._route.snapshot.queryParams;
                    
                    if (params['redirectURL']) {
                        this._router.navigate([params['redirectURL']]);
                    } else { 
                        this._router.navigate(['/home']);
                    }
                }
            }
        })
    }
}
